
import app from '../../App';

export default class RouteHelper {
    constructor ($route,$location) {

        'ngInject';
        this._$route=$route;
        this._$location=$location;
    }

    updateRouteParams(params){
        this._$route.updateParams(params);
    }

    updateLocation(param){
        this._$location.search(param);
    }
};

app.service( 'RouteHelper', RouteHelper );


// WEBPACK FOOTER //
// ./src/js/helpers/checkout-flow/RouteHelper.js